import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { Loading } from '../../components/Loading';
import { MainButton } from '../../components/MainButton'
import { ConfigType } from '../../contexts/AppConfigContext';
import { useAppConfig } from '../../hooks/useAppConfig';
import { useOrder } from '../../hooks/useOrder';
import { usePluginspace } from '../../hooks/usePluginspace';
import './index.css'

export function Receipt() {
    const { pluginspace_id } = useParams();
    const { registerAccess,pluginspace } = usePluginspace()
    const navigate = useNavigate();
    const { clearOrder, getReceipt, getOrderIdExt, synchronizeContextToStorage } = useOrder();

    const { getAppConfig } = useAppConfig();
    const [config, setConfig] = useState<ConfigType | void>();
    const [loading, setLoading] = useState(true);

    const [receipt, setReceipt] = useState('');
    const [orderIdExt, setOrderIdExt] = useState('');

    useEffect(() => {
        registerAccess('receipt')
        getConfig();
    }, []);

    async function getConfig(){
        setConfig(await getAppConfig());
        await loadOrder();
    }

    async function loadOrder() {
        await synchronizeContextToStorage();
        const receiptStorage = await getReceipt();
        const orderIdExtStorage = await getOrderIdExt();

        setReceipt(receiptStorage);
        setOrderIdExt(orderIdExtStorage);
        setLoading(false)
    }


    function orderFinished(){
        clearOrder();
        if(pluginspace?.type !== 'food'){
            navigate(`/${pluginspace_id}/new-success-order`);
          }else{
            navigate(`/${pluginspace_id}/success-order`);
          }
    }
    
    return (
        <div className="receipt">
            { loading ?
            <div style={{width: '100%', height: 'calc(100vh)'}}>
                <Loading
                    type="spinningBubbles"
                    color="#FFF"
                    width={64}
                    height={64}
                />
            </div>
            :
            <div className="content-receipt">
                <div className="body-receipt">
                    <h2>Comprovante</h2>
                    <div className="receipt-data">
                        <div className="row-center">
                            <p>{ receipt }</p>
                        </div>
                    </div>
                    <p className='order'>Seu pedido número { orderIdExt } foi enviado com sucesso!</p>
                </div>
                <div className="receipt-footer">
                    <MainButton 
                        color={config?.webappcolor.fontbutton ? config.webappcolor.fontbutton : '#636363'}
                        backgroundColor={config?.webappcolor.webappbutton ? config.webappcolor.webappbutton : '#EAEAEA'} 
                        text='Continuar' 
                        onClick={ orderFinished } 
                    />
                </div>
            </div>
            }
        </div>
    )
}